import { render } from "./index.vue?vue&type=template&id=7c941f5a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7c941f5a&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c941f5a"]])

export default __exports__